//Form Validation for submission
const Validator = require("validator");
const isEmpty = require("../../common/functions/is-empty");

export function validateItemInput(data) {
  let validationErrors = {};

  data.itemDescription = !isEmpty(data.itemDescription)
    ? data.itemDescription
    : "";
  data.specification = !isEmpty(data.specification) ? data.specification : "";

  data.quantityForSample = !isEmpty(data.quantityForSample)
    ? data.quantityForSample
    : "";
  data.preferredUnitOfMeasure = !isEmpty(data.preferredUnitOfMeasure)
    ? data.preferredUnitOfMeasure
    : "";
  data.productClass = !isEmpty(data.productClass) ? data.productClass : "";

  if (Validator.isEmpty(data.itemDescription)) {
    validationErrors.itemDescription = "Item Description field is required";
  }
  if (Validator.isEmpty(data.specification)) {
    validationErrors.specification = "Specification field is required";
  }
  if (Validator.isEmpty(data.quantityForSample)) {
    validationErrors.quantityForSample =
      "Quantity For Sample field is required";
  }
  if (Validator.isEmpty(data.preferredUnitOfMeasure)) {
    validationErrors.preferredUnitOfMeasure =
      "Unit Of Measure field is required";
  }
  if (Validator.isEmpty(data.productClass)) {
    validationErrors.productClass = "Product Class field is required";
  }

  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
